import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { virtualVS } from 'services/validations/catalog/virtual'
import { CustomFormProps } from 'types/common'
import VirtualFacetSection from 'ui-shared/Facets/FacetFormSections/VirtualFacetSection'
import ExperienceForm from 'ui-shared/Forms/ExperienceForm'

const VirtualExperiencesForm: React.FC<CustomFormProps> = (props) => (
  <ExperienceForm
    {...props}
    facetFields={<VirtualFacetSection />}
    upsellingEntity="virtualupselling"
    resolver={yupResolver(virtualVS)}
  />
)

export default VirtualExperiencesForm
